<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">盘点工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsDetail">
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-select v-model="status" style="width:120px">
            <a-select-option :value="1">待审核</a-select-option>
            <a-select-option :value="2">已通过</a-select-option>
            <a-select-option :value="3">已驳回</a-select-option>
          </a-select>
        </span>
        <span>
          <label>盘点日期：</label>
          <a-range-picker
            v-model="dateVal"
            @change="selectDate"
            :ranges="{
              今天: [moment(), moment()],
              本月: [moment().startOf('month'), moment()],
              上月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ]
            }"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="设备网点名称|设备网点地址|员工名称"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.create_time }}</td>
              <td>{{ item.user_name }}</td>
              <td>
                <p v-show="item.status == 1">待审核</p>
                <p v-show="item.status == 2">已通过</p>
                <p v-show="item.status == 3">已驳回</p>
              </td>
              <td class="operation">
                <a @click="detailPage(item)" style="color:#666">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 详情 -->
    <machineCheckDetail
      v-show="showIsDetail"
      :detailVal="detailVal"
      v-on:hideIsDetail="hideIsDetail"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import machineCheckDetail from "@/components/equipment/machineCheckDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "网点设备",
        "盘点时间",
        "盘点操作人",
        "状态",
        "操作"
      ],
      proList: [],
      showIsDetail: false,
      detailVal: "",
      status: "",
      project_id: "",
      query_field: "",
      start_date: "",
      end_date: "",
      dateVal: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    machineCheckDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    moment,
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_check/downloadGetDeviceCheckList?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&project_id=" +
        this.project_id +
        "&status=" +
        this.status;
    },
    selectDate(dates, dateStrings) {
      this.start_date = dateStrings[0];
      this.end_date = dateStrings[1];
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    backHref() {
      this.showIsDetail = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.status = "";
      this.start_date = "";
      this.end_date = "";
      this.project_id = "";
      this.query_field = "";
      this.dateVal = null;
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_check/getDeviceCheckList";
      let params = {
        current_page: this.page,
        per_page: 10,
        token: window.localStorage.getItem("xnwfPcToken"),
        status: this.status,
        start_date: this.start_date,
        end_date: this.end_date,
        project_id: this.project_id,
        query_field: this.query_field
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      this.detailVal = item;
      this.showIsDetail = true;
    },
    hideIsDetail(msg) {
      this.showIsDetail = false;
      if (msg) {
        this.reload();
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
